module.exports = {
      id: "ic-otcbadge-usage",
      viewBox: "0 0 13 9",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-otcbadge-usage",
      toString: function () {
        return this.url;
      }
    }